// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 引入 vue
import Vue from 'vue'
// 引入 app 组件
import App from './App'
// 引入路由
import router from './router/index'
// 引入基本样式及字体图标
import 'assets/stylus/index.styl'
// 引用API文件
import api from './api/index.js'
// 引入下载地址
import down from './down/index.js'
// 引入 vuex
// import store from './store/index'
// 表单验证插件
import 'lib/VeeValidate/index'
// 分页插件
import 'lib/vueInfiniteScroll/index'

// 将API方法绑定到全局
Vue.prototype.$api = api
// 将下载地址绑定到全局
Vue.prototype.$down = down

// 关闭生产模式调试信息
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js